module.exports = __webpack_public_path__ + "static/img/pk1.500da3e.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pk1.gif
// module id = E9qx
// module chunks = 1